import type { Process, ProcessNodeRef } from '../types';
import type { Segment } from '../migrations/legacyEdge';

export function buildEdgeMap(edges: Segment[]): Record<string, Segment> {
  return edges.reduce<Record<string, Segment>>((acc, edge) => {
    acc[edge.id] = edge;
    return acc;
  }, {});
}

export function resolveProcessEdges(process: Pick<Process, 'edgeIds'>, edgeMap: Record<string, Segment>): Segment[] {
  return (process.edgeIds ?? []).map(edgeId => edgeMap[edgeId]).filter((edge): edge is Segment => Boolean(edge));
}

export function resolveProcessEdgesFromList(process: Pick<Process, 'edgeIds'>, edges: Segment[]): Segment[] {
  const edgeMap = buildEdgeMap(edges);
  return resolveProcessEdges(process, edgeMap);
}

export function deriveProcessNodesFromEdges(edges: Segment[]): ProcessNodeRef[] {
  const nodeIds = new Set<string>();
  edges.forEach(edge => {
    nodeIds.add(edge.from);
    nodeIds.add(edge.to);
  });
  return Array.from(nodeIds).map(id => ({ id }));
}

export function makeStableEdgeId(procId: number, segIdx: number, seg: Pick<Segment, 'from' | 'to'>): string {
  return `p${procId}_e${segIdx}_${seg.from}_${seg.to}`;
}
